
export const TypeDocuments = Object.freeze({
  IS_LINK: 1,
  IS_DOCUMENT_PDF: 2,
  IS_FORMATTED_TEXT: 3
})

const ID_DOCUMENT_CODE_ETHICS = 93
const ID_DOCUMENT_TERMS_CONDITIONS = 578
const ID_DOCUMENT_NOTICE_PRIVACY = 579
const ID_DOCUMENT_COMPLAINTS = 580

export const documentsExceptionsDelete = [ID_DOCUMENT_CODE_ETHICS, ID_DOCUMENT_TERMS_CONDITIONS, ID_DOCUMENT_NOTICE_PRIVACY, ID_DOCUMENT_COMPLAINTS]
export const documentsExceptionsChangeType = [ID_DOCUMENT_CODE_ETHICS, ID_DOCUMENT_TERMS_CONDITIONS, ID_DOCUMENT_NOTICE_PRIVACY, ID_DOCUMENT_COMPLAINTS]
